var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c;
var URL_PROJETO = (_a = process.env.REACT_APP_URL_PROJETO) !== null && _a !== void 0 ? _a : "http://localhost:3000";
var PROJETO_CLIENT_ID = (_b = process.env.SMARTPASS_LOGIN_CLIENT_ID) !== null && _b !== void 0 ? _b : "portal-web";
var URL_MT_LOGIN = (_c = process.env.SMARTPASS_LOGIN_URL) !== null && _c !== void 0 ? _c : "https://dev.login.mt.gov.br";
var CONFIG = {
    GRANT_TYPE: "authorization_code",
    CLIENT_ID: PROJETO_CLIENT_ID,
    REDIRECT_URI: "".concat(URL_PROJETO, "/home"),
    URL_TOKEN: "".concat(URL_MT_LOGIN, "/realms/mt-realm/protocol/openid-connect/token"),
    URL_USER_INFO: "".concat(URL_MT_LOGIN, "/realms/mt-realm/protocol/openid-connect/userinfo"),
    URL_LOGIN: "".concat(URL_MT_LOGIN, "/realms/mt-realm/protocol/openid-connect/auth?client_id=").concat(PROJETO_CLIENT_ID, "&redirect_uri=").concat(URL_PROJETO, "/home&response_type=code"),
    URL_LOGOUT: "".concat(URL_MT_LOGIN, "/realms/mt-realm/protocol/openid-connect/logout?client_id=").concat(PROJETO_CLIENT_ID, "&redirect_uri=").concat(URL_PROJETO, "&response_type=code"),
};
export var verificarUsuarioLogado = function () { return __awaiter(void 0, void 0, Promise, function () {
    var params, code, tokenResponse, userData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams(window.location.search);
                code = params.get("code");
                if (!code) {
                    console.error("Erro: no code na resposta");
                    redirectToLogin();
                    return [2 /*return*/, null];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetchToken(code)];
            case 2:
                tokenResponse = _a.sent();
                if (!(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.access_token)) return [3 /*break*/, 4];
                return [4 /*yield*/, getDadosUsuarioLogadoPortalMT(tokenResponse.access_token)];
            case 3:
                userData = _a.sent();
                if (userData) {
                    salvarDadosUsuario(userData, tokenResponse.access_token);
                    return [2 /*return*/, userData];
                }
                _a.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                console.error("Erro ao verificar usuário logado", error_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/, null];
        }
    });
}); };
var fetchToken = function (code) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(CONFIG.URL_TOKEN, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        grant_type: CONFIG.GRANT_TYPE,
                        client_id: CONFIG.CLIENT_ID,
                        code: code,
                        redirect_uri: CONFIG.REDIRECT_URI,
                    }),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
var getDadosUsuarioLogadoPortalMT = function (accessToken) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!accessToken) {
                    accessToken = localStorage.getItem("access_token");
                }
                if (!accessToken)
                    return [2 /*return*/, null];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(CONFIG.URL_USER_INFO, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        },
                        body: new URLSearchParams({
                            access_token: accessToken,
                            client_id: CONFIG.CLIENT_ID,
                        }),
                    })];
            case 2:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, response.json()];
                }
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                console.error("Erro ao obter dados do usuário", error_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); };
var salvarDadosUsuario = function (userData, accessToken) {
    localStorage.setItem("usuarioLogado", JSON.stringify(userData));
    localStorage.setItem("access_token", accessToken);
};
var redirectToLogin = function () {
    window.location.href = CONFIG.URL_LOGIN;
};
export var getDadosUsuarioLogadoLocalStorage = function () {
    var usuarioLogadoJSON = localStorage.getItem("usuarioLogado");
    return usuarioLogadoJSON ? JSON.parse(usuarioLogadoJSON) : null;
};
export var getLogout = function () {
    localStorage.removeItem("usuarioLogado");
    localStorage.removeItem("access_token");
    window.location.href = CONFIG.URL_LOGOUT;
};
export var getURLMTLogin = function () { return CONFIG.URL_LOGIN; };
export var getURLMTLogout = function () { return CONFIG.URL_LOGOUT; };
